export const formatPattern = 'DD-MM-YYYY, HH:mm'
